/**
 * Утилиты для работы с допниками (addons).
 * API возвращает допники сгруппированными по типу: [{ type: "syrup"|"milk", positions: [...] }].
 * Эти функции нормализуют формат для использования во фронте.
 */

/** Подписи категорий допников для UI */
export const ADDON_TYPE_LABELS = {
  syrup: 'Сиропы',
  milk: 'Молоко',
  topping: 'Топпинг',
  urbech: 'Урбеч',
  flavor: 'Вкус',
  tonic: 'Тоник',
  lemonade_base: 'Основа лимонада',
};

/** Русская подпись категории допника для UI. */
export function getAddonTypeLabel(type) {
  if (type == null || type === '') return 'Дополнительно';
  const key = String(type).trim().toLowerCase();
  return ADDON_TYPE_LABELS[key] || ADDON_TYPE_LABELS[type] || 'Дополнительно';
}

/**
 * Проверяет, является ли массив addons сгруппированным форматом API
 * (массив объектов с полями type и positions).
 * @param {Array} addons
 * @returns {boolean}
 */
export function isGroupedAddons(addons) {
  if (!Array.isArray(addons) || addons.length === 0) return false;
  const first = addons[0];
  return first && typeof first === 'object' && 'type' in first && Array.isArray(first.positions);
}

/**
 * Возвращает плоский список допников из любого формата:
 * - сгруппированный API: [{ type, positions }, ...] → positions объединяются;
 * - плоский (обратная совместимость): [{ id, name, ... }, ...] → как есть.
 * @param {Array} addons - addons из API или из корзины
 * @returns {Array} массив объектов допников
 */
export function getAddonsFlat(addons) {
  if (!addons || !Array.isArray(addons)) return [];
  if (isGroupedAddons(addons)) {
    return addons.flatMap((group) => group.positions || []);
  }
  return addons;
}

/**
 * Возвращает группы допников в формате [{ type, positions }, ...].
 * Если пришёл плоский список (старый формат), возвращает одну группу с type 'syrup'.
 * @param {Array} addons - addons из API
 * @returns {Array<{ type: string, positions: Array }>}
 */
export function getAddonGroups(addons) {
  if (!addons || !Array.isArray(addons)) return [];
  if (isGroupedAddons(addons)) {
    return addons.filter((g) => g.positions && g.positions.length > 0);
  }
  if (addons.length > 0) {
    return [{ type: 'syrup', positions: addons }];
  }
  return [];
}

/**
 * Количество допников (по плоскому списку).
 * @param {Array} addons
 * @returns {number}
 */
export function getAddonsCount(addons) {
  return getAddonsFlat(addons).length;
}
